console.log('SCRIPT_LOAD: removeBaseURL.js.lqd');

function RemoveBaseUrl(url) {
    var currentDomain = window.location.hostname; // Get the current domain
    var baseUrlPattern = /^(http|https)?:\/\/brickellmensproducts.(com|ca|co.uk|com.au|it|de|in)+/;
    var newBaseUrl = "https://" + currentDomain;
    var result = "";

    var match = baseUrlPattern.exec(url);
    if (match != null) {
      result = match[0];
    }

    if (result.length > 0) {
      if (url.lastIndexOf("https://brickellmensproducts.ca/discount/") > -1) {
        // Do nothing if the URL contains the specific discount link
      } else {
        url = url.replace(result, newBaseUrl); // Replace with the current domain's URL
      }
    }
    return url;
  }

  function updateLinks() {
    var articleLinks = document.querySelectorAll('article a');
    articleLinks.forEach(function(link) {
      link.href = RemoveBaseUrl(link.href);
    });
  }

  function docReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  docReady(updateLinks);